<template>
  <div class="content">
    <div class="container-fluid">

    <button type="button" class="btn btn-primary btn-small" @click="Toggle()">Add</button>

    <transition name="fade">

        <card v-if="ShowAddLocation" class="AddForm">

          <form v-on:submit.prevent="Save()">

            <div class="row">
              <div class="col-md-12">
                <p class="Hide" style="float: right;" @click="Hide()"><i class="nc-icon nc-simple-remove"></i></p>
                <h4 slot="header" class="card-title">Add Location</h4>
              </div>
            </div>


            <div class="row">

              <div class="col-md-3">
                <base-input type="text"
                          label="Location"
                          placeholder="Front Desk, Main Entrance etc"
                          v-model="user.Location"
                          required>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input type="text"
                          label="Name"
                          placeholder="John Doe"
                          v-model="user.ContactPerson"
                          required>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input type="text"
                          label="Mobile"
                          placeholder=""
                          v-model="user.Mobile"
                          required>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input type="email"
                          label="Email"
                          placeholder=""
                          v-model="user.Email"
                          required>
                </base-input>
              </div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-primary btn-fill float-right">
                Save
              </button>
            </div>
            <div class="clearfix"></div>
          </form>

        </card>

    </transition>



  <transition name="fade">

      <card v-if="ShowEditLocation" class="AddLocationForm">

        <form v-on:submit.prevent="Edit()">

          <div class="row">
            <div class="col-md-12">
              <p class="Hide" style="float: right;" @click="CloseEditLocation()"><i class="nc-icon nc-simple-remove"></i></p>
              <h4 slot="header" class="card-title">Edit Location</h4>
            </div>
          </div>


          <div class="row">

            <div class="col-md-3">
              <base-input type="text"
                        label="Location"
                        placeholder="Front Desk, Main Entrance etc"
                        v-model="FormInfo.Location"
                        required>
              </base-input>
            </div>

            <div class="col-md-3">
              <base-input type="text"
                        label="Name"
                        placeholder="John Doe"
                        v-model="FormInfo.ContactPerson"
                        required>
              </base-input>
            </div>

            <div class="col-md-3">
              <base-input type="text"
                        label="Mobile"
                        placeholder=""
                        v-model="FormInfo.Mobile"
                        required>
              </base-input>
            </div>

            <div class="col-md-3">
              <base-input type="email"
                        label="Email"
                        placeholder=""
                        v-model="FormInfo.Email"
                        required>
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <button type="submit" class="btn btn-primary btn-fill float-right">
              Save
            </button>
          </div>
          <div class="clearfix"></div>
        </form>

      </card>

  </transition>


      <!-- Show Table -->
      <div class="row" v-if="ShowTable">

            <div class="col-md-12 table1">
              <card class="strpied-tabled-with-hover">
              <!-- <card class="card-plain"> -->
                <template slot="header">
                  <h4 class="card-title">Tablet Management</h4>
                  <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                </template>
                <div class="table-responsive">

                    <table class="table table-hover table-sm" id="TabletManagement">
                      <thead>
                        <slot name="columns">
                          <tr>
                            <th v-for="column in columns">{{column}}</th>
                          </tr>
                        </slot>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in List" :key="index">
                          <slot :row="item">
                            <td>{{item.Location}}</td>
                            <td>{{item.ContactPerson}}</td>
                            <td>{{item.Mobile}}</td>
                            <td>{{item.Email}}</td>

                            <td>
                              <div class="custom-control custom-switch" @click="EnableWhomToMeet(item.id)" v-if="!item.Parameters.WhomToMeet">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="item.Parameters.WhomToMeet"  disabled=true>
                                <label class="custom-control-label" for="customSwitch1"></label>
                              </div>                              

                              <div class="custom-control custom-switch" v-if="item.Parameters.WhomToMeet">
                                <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="item.Parameters.WhomToMeet" @click="DisableWhomToMeet(item.id)">
                                <label class="custom-control-label" for="customSwitch2"></label>
                              </div>                              

                            </td>

                            <td>

                              <div class="custom-control custom-switch" @click="EnableVisitPurpose(item.id)" v-if="!item.Parameters.VisitType">
                                <input type="checkbox" class="custom-control-input" id="customSwitch3" v-model="item.Parameters.VisitType"  disabled=true>
                                <label class="custom-control-label" for="customSwitch3"></label>
                              </div>                              

                              <div class="custom-control custom-switch" v-if="item.Parameters.VisitType">
                                <input type="checkbox" class="custom-control-input" id="customSwitch4" v-on:change="DisableVisitPurpose(item.id)" v-model="item.Parameters.VisitType">
                                <label class="custom-control-label" for="customSwitch4"></label>
                              </div>                              

                            </td>


                            <td>
                              <div class="custom-control custom-switch" @click="EnableApprovalRequired(item.id)" v-if="!item.Parameters.ApproveVisitor">
                                <input type="checkbox" class="custom-control-input" id="customSwitch5" v-model="item.Parameters.ApproveVisitor"  disabled=true>
                                <label class="custom-control-label" for="customSwitch5"></label>
                              </div>                              

                              <div class="custom-control custom-switch" v-if="item.Parameters.ApproveVisitor">
                                <input type="checkbox" class="custom-control-input" id="customSwitch6" v-model="item.Parameters.ApproveVisitor" @click="DisableApprovalRequired(item.id)">
                                <label class="custom-control-label" for="customSwitch6"></label>
                              </div>                              

                            </td>
                        

                            <td>{{item.CreatedOn | formatDate}}</td>
                            <td>{{item.LastUpdated | formatDate}}</td>

<!--                             <td>

                              <div class="custom-control custom-switch" v-if="item.Active">
                                <input type="checkbox" class="custom-control-input" id="customSwitch10" @click="MakeInactive(item.id)" v-model="item.Active">
                                <label class="custom-control-label" for="customSwitch10"></label>
                              </div>                                                            

                              <div class="custom-control custom-switch" v-if="!item.Active">
                                <input type="checkbox" class="custom-control-input" id="customSwitch11" @click="MakeActive(item.id)" v-model="item.Active">
                                <label class="custom-control-label" for="customSwitch11"></label>
                              </div>                                                            

                            </td> -->

                            <td>
                              <i class="fa fa-pencil" aria-hidden="true" @click="EditLocation(item)"></i>
                            </td>
                            <td></td>
                          </slot>
                        </tr>
                      </tbody>
                    </table>



<!--                   <l-table class="table-hover"
                           :columns="table2.columns"
                           :data="table2.data" id="Visitors">
                  </l-table> -->
                </div>
              </card>
            </div>
    
        </div>

      </div>


    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import moment from 'moment';

  // Require needed datatables modules
  require('datatables.net')


  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        ShowAddLocation: false,
        ShowEditLocation: false,
        ShowTable: true, 
        CompanyId: '',
        user: {
          Location: '',
          ContactPerson: '',
          Email: '',
          Mobile: ''
        },
        List: [],
        columns: [
        'Location',
        'Name',
        'Mobile',
        'Email',
        'Whom To Meet',
        'Purpose of Visit',
        'Approval Required',
        'Created On',
        'Last Updated',
        // 'Status',
        '',
        '',
        ],
      }
    },
    beforeMount(){
      console.log("beforeMount");
    },
    mounted(){
      console.log("Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);

      console.log("Country Code: "+globalStore.UserInfo.CountryCode);
      this.user.Mobile = globalStore.UserInfo.CountryCode;

      this.GetLocations();

    },
    beforeUnmount(){

    },
    methods:{
      Toggle(){

            console.log("Toggle Add Location");

        if(globalStore.PricePlan == 'Community'){
          var msg = "Sorry, this feature is not available for Community subscription "
          this.notifyVue('top', 'center', msg, 'danger', 'nc-icon nc-simple-remove');          

        }else{

            if(this.ShowAddLocation){
              this.ShowAddLocation = false;
            }else{
              this.ShowAddLocation = true;
            }

        }

      },
      EditLocation(info){

            console.log("Toggle Edit Location");

            this.FormInfo = info;
            this.ShowEditLocation = true;

      },
      CloseEditLocation(){
        this.ShowEditLocation = false;
      },
      Hide(){

            if(this.ShowAddLocation){
              this.ShowAddLocation = false;
            }else{
              this.ShowAddLocation = true;
            }
      },
      Edit(){
        console.log("Edit Location");
        console.log(this.FormInfo);
        this.FormInfo.LastUpdated = moment().format();

           db.collection("Location")
          .doc(this.FormInfo.id)
          .update(this.FormInfo)
          .then(() => {
            console.log('Data Updated - Success');

                      this.ShowEditLocation = false;

                      var msg = "Added Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#TabletManagement').DataTable();             
                      table.destroy();            

                      this.GetLocations();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });

      },
      Save(){

        console.log("Add Location");
        console.log(this.user);


          this.user.Notes = "";
          this.user.CompanyId = this.CompanyId;
          this.user.CompanyName = globalStore.CompanyName ;
          this.user.CreatedBy = "Admin";
          this.user.Address = "Admin";
          this.user.GoogleMapURL = "Admin";
          this.user.LastUpdated = " - ";
          this.user.CreatedOn = moment().format();
          this.user.Active = true;

            this.user.VisitPurpose = [
              "Guest",
              "Meeting",
              "Delivery",
              "Repair & Services",
              "Emergency Services",
              "Other"
            ];

            this.user.Parameters = {
              ApproveVisitor: false,
              VisitType: false,
              WhomToMeet: false
            };

          console.log("Payload: "+JSON.stringify(this.user));

             db.collection("Location")
            .add(this.user)
            .then(() => {
              console.log('Location Added - Success');

                      this.ShowAddLocation = false;

                      var msg = "Added Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#TabletManagement').DataTable();             
                      table.destroy();            

                      this.GetLocations();        

            })
            .catch(error => {
                console.error("Error: ", error);
            });


      },
    GetLocations(){

      this.ShowLoading = true;
      console.log('Get Locations');
      console.log("CompanyId: "+this.CompanyId)

      //-------- fetch all agents -------
      this.List = []

      db.collection('Location')
        .where("CompanyId","==",this.CompanyId)
        .where("Active","==",true)
        .get()
        .then((snap) => {

          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            // console.log("Doc is: " + doc.id);


            var Email = "";

            if(doc.data().Email){
              Email = doc.data().Email;
            }

            var LastUpdated = "";

            if(doc.data().LastUpdated){
              LastUpdated = doc.data().LastUpdated;
            }

            this.List.push({
              id: doc.id ,
              Location: doc.data().Location,
              ContactPerson: doc.data().ContactPerson,
              Mobile: doc.data().Mobile,
              Email: Email,
              CompanyId: doc.data().CompanyId,
              CompanyName: doc.data().CompanyName,
              Address: " ",
              GoogleMapURL: " ",
              LastUpdated: LastUpdated,
              VisitPurpose: doc.data().VisitPurpose,
              Parameters: doc.data().Parameters,
              CreatedOn: doc.data().CreatedOn,
              Notes: doc.data().Notes,
              Active: doc.data().Active,
            });
          });

          setTimeout(()=>{
            console.log('Locations:',this.List.length);

            this.ShowLoading = false;
            this.initializeDataTable();
          },200)


        })
        .catch((e) => {
          console.log('Error:', (e));
        });


    },
    notifyVue (verticalAlign, horizontalAlign, msg, type, icon) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: msg,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
    },    
    // ----------------------- Enable / Disable WhomToMeet
    EnableWhomToMeet(id){

      console.log("EnableWhomToMeet")

      console.log(globalStore.PricePlan);
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.WhomToMeet': true,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        


            });
        
        }
    
    },
    DisableWhomToMeet(id){
      console.log("DisableWhomToMeet")
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.WhomToMeet': false,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
            

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        

            });

      }

    },
    // ----------------------- Enable / Disable Visity Purpose
    EnableVisitPurpose(id){

      console.log("EnableVisitPurpose")

      console.log(globalStore.PricePlan);
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.VisitType': true,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');



            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        


            });
        
        }
    
    },
    DisableVisitPurpose(id){
      console.log("DisableVisitPurpose")
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.VisitType': false,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
            

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        

            });

      }

    },
    // ----------------------- Enable / Disable Approval Required
    EnableApprovalRequired(id){

      console.log("EnableApprovalRequired")

      console.log(globalStore.PricePlan);
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.ApproveVisitor': true,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');



            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        


            });
        
        }
    
    },
    DisableApprovalRequired(id){
      console.log("DisableApprovalRequired")
      console.log("LocationId: "+id);

      if(globalStore.PricePlan == 'Community'){
        var msg = "Sorry, this feature is not available for Community subscription "
        this.notifyVue('bottom', 'right', msg, 'danger', 'nc-icon nc-simple-remove');
      }else{
        console.log("Update Database");

             db.collection("Location")
            .doc(id)
            .update({
              'Parameters.ApproveVisitor': false,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
            

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        

            });

      }

    },
    MakeInactive(id){
      console.log("Make Inactive");

             db.collection("Location")
            .doc(id)
            .update({
              Active: false,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
            

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        

            });

    },
    MakeActive(id){
      console.log("Make Active");

             db.collection("Location")
            .doc(id)
            .update({
              Active: true,
              LastUpdated: moment().format()
            })
            .then(() => {
            //   swal("Data has been added successfully  :)");
              console.log('Updated - Success');

            var msg = "Updated Successfully"
            this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
            

            var table = $('#TabletManagement').DataTable();             
            table.destroy();            

            this.GetLocations();        

            });

    },
      initializeDataTable(){
        console.log("initializeDataTabl")

        setTimeout(() => {
          this.$nextTick(() => {


            $("#TabletManagement").DataTable({
              sDom: '<"top"f>rt<"bottom"i><"clear">',
              // dom: 'ifBtlp',
              fixedHeader: true,
              buttons: [
                {
                  extend: "csvHtml5",
                  text: "EXPORT",
                  title: "DataTable"
                }
              ]
            });

          });
        }, 100);


      },      
    }
  }
</script>
<style scoped="">

  .stats{
    border: 1px solid #DCDCDC;
    border-radius: 0.5em;
  }

  .Label{
    color: #707070;
  }

  .table1{
    margin-top: 1em;
  }

.dt-button.buttons-csv.buttons-html5{
  margin-left: 20em;
  background: #00b33c;
  border: 1px solid #00b33c;
  color: #ffffff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
}

#Visitors_filter.dataTables_filter{
    /*margin-left: 5em;*/
  }

  .nc-check-2{
    color: green;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.Hide{
  cursor: pointer;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #1abc9c;
    background-color: #1abc9c;
}


</style>
